export default __webpack_public_path__ + "static/276-ad2dfeeb45f813c1c3ee533fc8297add.gif";